import { rootApi } from "../../api/rootApi";

export const approvalLogApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    submitForApproval: builder.mutation({
      query: (params) => ({
        method: "POST",
        url: `/tenant/approval-log/submit`,
        headers: { Authorization: "Bearer " + params.token, slug: params.tenant_id },
        body: params.data,
      }),
    }),
    getPendingApprovalQueue: builder.mutation({
      query: (params) => ({
        method: "GET",
        url: `/tenant/approval-log/pending?limit=${params.limit || 10}&offset=${params.offset || 0}`,
        headers: { Authorization: "Bearer " + params.token, slug: params.tenant_id },
      }),
    }),
    getAllApprovalRequests: builder.mutation({
      query: (params) => ({
        method: "GET",
        url: `/tenant/approval-log/all?limit=${params.limit || 10}&offset=${params.offset || 0}${params.status ? `&status=${params.status}` : ""}${params.entity_type ? `&entity_type=${params.entity_type}` : ""}`,
        headers: { Authorization: "Bearer " + params.token, slug: params.tenant_id },
      }),
    }),
    getApprovalRequestHistory: builder.mutation({
      query: (params) => ({
        method: "GET",
        url: `/tenant/approval-log/history/${params.workflow_id}/${params.ref_table_id}`,
        headers: { Authorization: "Bearer " + params.token, slug: params.tenant_id },
      }),
    }),
    // Fetch approval logs by ref_table_name + ref_table_id (no workflow_id needed)
    getApprovalLogsByRef: builder.mutation({
      query: (params) => ({
        method: "GET",
        url: `/tenant/approval-log/by-ref/${params.ref_table_name}/${params.ref_table_id}`,
        headers: { Authorization: "Bearer " + params.token, slug: params.tenant_id },
      }),
    }),
    // Batch: get can_approve / is_fully_approved for a list of row IDs
    getBatchApprovalStatus: builder.mutation({
      query: (params) => ({
        method: "POST",
        url: `/tenant/approval-log/batch-status`,
        headers: { Authorization: "Bearer " + params.token, slug: params.tenant_id },
        body: { ref_table_name: params.ref_table_name, ref_ids: params.ref_ids },
      }),
    }),
    // Approve or reject a gift redemption through the workflow gate
    giftWorkflowAction: builder.mutation({
      query: (params) => ({
        method: "POST",
        url: `/tenant/approval-log/gift-workflow-action`,
        headers: { Authorization: "Bearer " + params.token, slug: params.tenant_id },
        body: { ref_no: params.ref_no, action: params.action, remark: params.remark },
      }),
    }),
    approveApprovalRequest: builder.mutation({
      query: (params) => ({
        method: "POST",
        url: `/tenant/approval-log/approve`,
        headers: { Authorization: "Bearer " + params.token, slug: params.tenant_id },
        body: params.data,
      }),
    }),
    rejectApprovalRequest: builder.mutation({
      query: (params) => ({
        method: "POST",
        url: `/tenant/approval-log/reject`,
        headers: { Authorization: "Bearer " + params.token, slug: params.tenant_id },
        body: params.data,
      }),
    }),
  }),
});

export const {
  useSubmitForApprovalMutation,
  useGetPendingApprovalQueueMutation,
  useGetAllApprovalRequestsMutation,
  useGetApprovalRequestHistoryMutation,
  useGetApprovalLogsByRefMutation,
  useGetBatchApprovalStatusMutation,
  useGiftWorkflowActionMutation,
  useApproveApprovalRequestMutation,
  useRejectApprovalRequestMutation,
} = approvalLogApi;
